import { useCountriesQuery } from 'common/hooks/useCountries';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedCountryCodes } from 'common/hooks/useSelectedCountryCodes';

import { useBrandsQuery } from './query';

export const useBrandsFilterTagText = (brandIds: string[]) => {
  const f = useFormatMessage();
  const selectedCountryCodes = useSelectedCountryCodes();
  const { data: countries } = useCountriesQuery();

  const selectedCountryDefaultLanguageCode = countries?.find(
    (country) => country.countryCode === selectedCountryCodes[0],
  )?.defaultLanguageCode;

  const languageCode =
    selectedCountryCodes.length === 1 && selectedCountryDefaultLanguageCode
      ? selectedCountryDefaultLanguageCode
      : 'en';

  const { data: brands } = useBrandsQuery({ languageCode }, Boolean(brandIds.length));

  return brandIds.map((id, index) => {
    if (index === 0) {
      const selectedBrand = brands?.find((brand) => brand.id === id);
      return selectedBrand
        ? `${selectedBrand.name}${selectedBrand.owner.name ? ` (${selectedBrand.owner.name})` : ''}`
        : f('common.unknown');
    }

    return id;
  });
};
